import React, { useEffect, useState } from 'react';
import {
  depositETH,
} from '../../functions/lendingfunctions.js';
import BorrowingPosition from './BorrowingPosition.js';
import LendingPosition from './LendingPosition.js';

const verifiedTokens = [
  '0xdAC17F958D2ee523a2206206994597C13D831ec7', // USDT
  '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', // USDC
];

export default function MyPositions({ signer,lendETHPositions ,handleWithdrawETH,borrowedETHPositions,lentTaken}) {
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [ethAmount, setEthAmount] = useState('');

  useEffect(() => {
    async function fetchAllPositions() {
      try {
        setIsLoading(true);
      } catch (error) {
        console.error('Error fetching positions:', error);
      } finally {
        setIsLoading(false);
      }
    }
    fetchAllPositions();
  }, [signer]);


  // Close the modal
  const handleCloseModal = () => {
    setShowModal(false);
    setEthAmount('');
  };

  return (
    <div className="w-full">
      {/* --------------- BORROW POSITIONS --------------- */}
      <div className="mt-3 mb-2 flex justify-between items-center">
        <div className='flex '>
          <h2 className="text-[19px] sm:text-[19px] md:text-[23px] text-start font-semibold">My Borrow Positions</h2>

          {}
  
          {}
        </div>
        <div />
      </div>

      {/* Table Header */}
      <div className="grid grid-cols-5 md:grid-cols-6 p-2 border-b text-white/50 font-[300] border-white/10 text-[9px] xxs:text-[11px] sm:text-[14px]">
        <div className="flex justify-start">Asset</div>
        <div className='hidden md:block'>Borrowed ETH </div>
        <div>Lent Tokens</div>

        <div className='hidden sm:block'>My Rewards</div>
        <div className='block sm:hidden'>Rewards</div>        <div>Lock Time</div>
        <div className="text-right">Actions</div>
      </div>

      {/* Table Body: Borrow Positions */}
      {isLoading ? (
        // Skeleton while loading
        verifiedTokens.map((_, index) => (
          <div
          key={index}
          className="grid grid-cols-5 md:grid-cols-6 p-2 border-b border-white/10 text-white/50 font-[300] text-[9px] xxs:text-[11px] sm:text-[14px]"
        >
          {/* 1) Asset */}
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 bg-white/10 rounded" />
            <div className="w-16 h-4 bg-white/10 rounded" />
          </div>
        
          {/* 2) ETH Lent */}
          <div className="w-16 h-4 bg-white/5 rounded" />
        
          {/* 3) Tokens Deposited (hidden on small screens, shown on md) */}
          <div className="hidden md:block w-20 h-4 bg-white/5 rounded" />
        
          {/* 4) My Rewards / Rewards + tooltip icon */}
          <div className="flex justify-center items-center gap-2">
            <div className="w-16 h-4 bg-white/5 rounded" />
            {/* Tooltip icon placeholder */}
            <div className="w-3 h-3 bg-white/10 rounded" />
          </div>
        
          {/* 5) Lock Time */}
          <div className="w-16 h-4 bg-white/5 rounded" />
        
          {/* 6) Actions (on md screens) */}
          <div className="hidden md:flex justify-end">
            <div className="w-16 h-4 bg-white/5 rounded" />
          </div>
        </div>
        
        ))
      ) : (borrowedETHPositions?.length === 0 || borrowedETHPositions === null)  ? (
        <div className="text-[12px] xxs:text-sm md:text-[15px] p-4 text-center text-white/50">No active borrow positions</div>
      ) : (
        borrowedETHPositions.map((position, index) => (
          <BorrowingPosition position={position} signer={signer} />
        ))
      )}

      {/* --------------- LEND POSITIONS --------------- */}
      <div className="mt-10 mb-2 flex justify-between items-center">
        <div className='flex items-center'>
          <h2 className="text-[19px] sm:text-[19px] md:text-[23px] text-start font-semibold">My Lend Positions</h2>
            
          {}
        
      <p className="ml-2 xxs:ml-4 sm:flex sm:gap-4 font-[400] text-[12px] sm:text-[13px] text-white/40 text-start ">
        {lendETHPositions && (
          <>
            <span className="block">
            {lendETHPositions && "Available ETH: "}

              {`${Math.round(lendETHPositions.ETHAvailable * 10000) / 10000}`}
            </span>
            <span className="block">
              {`Lended ETH : ${Math.round((lendETHPositions.totalLent-lendETHPositions.ETHAvailable) * 10000) / 10000}`}
            </span>
          </>
        )}
      </p>

        </div>
      </div>

      {/* Table Header */}
      <div className="grid grid-cols-5 md:grid-cols-6 p-2 border-b text-white/50 font-[300] border-white/10 text-[9px] xxs:text-[11px] sm:text-[14px]">
        <div className="flex justify-start">Asset</div>
        <div>ETH Lent</div>
        <div className='hidden md:block'>Tokens Deposited</div>
          <div className='flex justify-center'>
            <p className='hidden sm:block'>My Rewards</p>
            <p className='block sm:hidden'>Rewards</p>
            <div className="relative inline-block ml-1">
              {/* The "group" container: */}
              <div className="group relative w-3 h-3">
                {/* Icon itself: */}
                <div className="flex items-center justify-center w-full h-full rounded-full bg-gray-800 text-white text-[11px] cursor-pointer">
                  !
                </div>
                
                {/* Tooltip content */}
                <div
                  className="
                    pointer-events-none
                    absolute
                    left-1/2
                    top-full
                    -translate-x-1/2
                    mt-2
                    w-[200px]
                    whitespace-normal
                    break-words
                    bg-[#1a1918]
                    border border-yellow-400/40
                    text-gray-300
                    text-xs
                    py-3
                    px-4
                    
                    opacity-0
                    group-hover:opacity-100
                    transition-opacity
                    z-50
                  "
                >
                  This reward represents current rewards generated by on-going borrows , it doesn't include rewards given to lenders on very swap. 
                </div>
              </div>
            </div>
          </div>
        <div>Lock Time</div>
        <div className="text-right">Actions</div>
      </div>

      {/* Table Body: Lend Positions */}
      {isLoading ? (
        // Skeleton rows while loading
        verifiedTokens.map((_, index) => (
          <div
            key={index}
            className="grid grid-cols-5 items-center hover:bg-white/5 py-2 px-2 text-sm"
          >
            {/* Asset Skeleton */}
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 bg-white/10 rounded" />
              <div className="w-24 h-4 bg-white/10 rounded" />
            </div>
            <div className="ml-2 w-24 h-4 bg-white/5 rounded" />
            <div className="ml-2 w-24 h-4 bg-white/5 rounded" />
            <div className="ml-2 w-24 h-4 bg-white/5 rounded" />
            <div className="ml-2 w-24 h-4 bg-white/5 rounded" />
            <div className="ml-2 w-20 h-4 bg-white/5 rounded justify-self-end" />
          </div>
        ))
      ) : (!lentTaken || lentTaken.length <= 0) ? (
        <div className="text-[12px] xxs:text-sm md:text-[15px] p-4 text-center text-white/50">No active loan positions</div>
      ) : (<>
          {}
          {lentTaken && lentTaken.length >0 && 
            lentTaken.map((position, index) => (
              <LendingPosition signer={signer} position={position} />
            ))
          }
          </>

      )}

      {/* ----------------- Provide ETH Modal ----------------- */}
      {showModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-gray-800 p-6 rounded-md w-[400px] relative">
            <button
              onClick={handleCloseModal}
              className="absolute top-2 right-2 text-white/60 hover:text-white"
            >
              X
            </button>
            <h3 className="text-xl font-semibold mb-4">Provide ETH</h3>
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Amount (ETH):</label>
              <input
                type="number"
                step="0.01"
                className="w-full p-2 rounded bg-gray-700 text-white outline-none"
                value={ethAmount}
                onChange={(e) => setEthAmount(e.target.value)}
              />
            </div>
            <button
              className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded"
              onClick={async () => {
                try {
                  // Provide ETH logic
                  await depositETH(signer, ethAmount);
                  handleCloseModal();
                } catch (error) {
                  console.error('Error depositing ETH:', error);
                }
              }}
            >
              Confirm
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
